import React from 'react';

import { AnchorWithTitle } from '@/components/links/anchor';
import * as CallButtons from '../icons/IconCall';

const CallBtn = (callIconVariant: any) => {
  const getVariantCallIcon = (variant: any) => {
    switch (variant) {
      case 'theme':
      case 'primary':
        return <CallButtons.IconCallTheme />;

      case 'white':
        return <CallButtons.IconCallWhite />;

      default:
        return <CallButtons.IconCallTheme />;
    }
  };

  const callIcon = getVariantCallIcon(callIconVariant);

  return (
    <AnchorWithTitle
      href="tel:8137428178"
      className="topbarBtn"
    >
      {callIcon}
    </AnchorWithTitle>
  );
};

export default CallBtn;
